/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/creditcard/CreditCardScannerIntroScreenConfiguration.yaml
import { BackgroundStyle, ButtonConfiguration, ForegroundStyle, StyledText } from '../../ui_v2/common/Common';
import { PartiallyConstructible } from '../../utils/utils';
/** @internal */
export var CreditCardScannerIntroImage;
(function (CreditCardScannerIntroImage) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'CreditCardIntroOneSideImage':
                return new CreditCardIntroOneSideImage(source);
            case 'CreditCardIntroTwoSidesImage':
                return new CreditCardIntroTwoSidesImage(source);
            case 'CreditCardNoImage':
                return new CreditCardNoImage(source);
            case 'CreditCardIntroCustomImage':
                return new CreditCardIntroCustomImage(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    CreditCardScannerIntroImage.From = From;
})(CreditCardScannerIntroImage || (CreditCardScannerIntroImage = {}));
/**
The image for the introduction screen with one side of a credit card.
*/
export class CreditCardIntroOneSideImage extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CreditCardIntroOneSideImage>`} */
    constructor(source = {}) {
        super();
        this._type = 'CreditCardIntroOneSideImage';
    }
}
/**
The image for the introduction screen with two sides of a credit card.
*/
export class CreditCardIntroTwoSidesImage extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CreditCardIntroTwoSidesImage>`} */
    constructor(source = {}) {
        super();
        this._type = 'CreditCardIntroTwoSidesImage';
    }
}
/**
No image for the introduction screen.
*/
export class CreditCardNoImage extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CreditCardNoImage>`} */
    constructor(source = {}) {
        super();
        this._type = 'CreditCardNoImage';
    }
}
/**
A custom image for the introduction screen.
*/
export class CreditCardIntroCustomImage extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CreditCardIntroCustomImage>`} */
    constructor(source = {}) {
        super();
        this._type = 'CreditCardIntroCustomImage';
        if (source.uri !== undefined) {
            this.uri = source.uri;
        }
        else {
            throw new Error('uri must be present in constructor argument');
        }
    }
}
/**
Configuration of the introduction screen for the credit card scanner.
*/
export class CreditCardScannerIntroScreenConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CreditCardScannerIntroScreenConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          The image for the introduction screen.
          */
        this.image = new CreditCardIntroOneSideImage({});
        /**
          The background color of the introduction screen.
          
          Default is "?sbColorSurface"
          */
        this.backgroundColor = '?sbColorSurface';
        /**
          The divider color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.dividerColor = '?sbColorOutline';
        /**
          The handle color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.handlerColor = '?sbColorOutline';
        /**
          Determines whether the introduction screen should automatically be shown or not when the scanning session starts.
          
          Default is false
          */
        this.showAutomatically = false;
        /**
          The title of the introduction screen, located in the top bar.
          */
        this.title = new StyledText({ text: '?introScreenTitle', color: '?sbColorOnSurface' });
        /**
          The text explanation of the introduction screen.
          */
        this.explanation = new StyledText({ text: '?introScreenText', color: '?sbColorOnSurface' });
        /**
          Configuration of the 'Done' / 'Start scanning' button.
          */
        this.doneButton = new ButtonConfiguration({
            text: '?introScreenDoneButton',
            accessibilityDescription: '?accessibilityDescriptionIntroScreenDoneButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '?sbColorPrimary', strokeWidth: 0.0 }),
            foreground: new ForegroundStyle({ color: '?sbColorOnPrimary' }),
        });
        if (source.image !== undefined) {
            this.image = CreditCardScannerIntroImage.From(source.image);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.dividerColor !== undefined) {
            this.dividerColor = source.dividerColor;
        }
        if (source.handlerColor !== undefined) {
            this.handlerColor = source.handlerColor;
        }
        if (source.showAutomatically !== undefined) {
            this.showAutomatically = source.showAutomatically;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.explanation !== undefined) {
            this.explanation = new StyledText(source.explanation);
        }
        if (source.doneButton !== undefined) {
            this.doneButton = new ButtonConfiguration(source.doneButton);
        }
    }
}
//# sourceMappingURL=CreditCardScannerIntroScreenConfiguration.js.map